import { FunctionComponent, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { t } from '@/utils/i18n';
import { useReduxDraftDispatch } from '@/redux/draft/draftDispatch';
import { getDraft } from '@/redux/draft/getters/getDraft';
import { StoreState } from '@/redux/types';
import { Info } from '@/components/common/icons/Info';
import { setWarningAction } from '@/components/draft/draftState/actions/setWarningAction';
import { Close } from './icons/Close';
import './WarningList.scss';

interface WarningItemProps {
  id: string;
  warning: string;
}

const WarningItem: FunctionComponent<WarningItemProps> = ({ warning, id }) => {
  const dispatch = useReduxDraftDispatch();
  const hideWarning = useCallback(() => {
    dispatch(setWarningAction(id));
  }, [dispatch, id]);

  useEffect(() => {
    const timer = setTimeout(hideWarning, 7500);
    return () => clearTimeout(timer);
  }, [hideWarning]);

  const message = t(`${warning}`);

  return (
    <div className="warning-message-list__item">
      <Info className="warning-message-list__info-icon" />
      <span className="warning-message-list__message">{message}</span>
      <button className="warning-message-list__close" onClick={hideWarning}>
        <Close onClick={hideWarning} className="warning-message-list__close-icon" />
      </button>
    </div>
  );
};

export const WarningList: FunctionComponent = () => {
  const warnings = useSelector((state: StoreState) => getDraft(state).warnings);
  const items = Object.entries(warnings).map(([key, warning]) => {
    return <WarningItem key={`W${key}_${warning}`} id={key} warning={warning} />;
  });

  if (!items || !items.length) {
    return null;
  }

  return <div className="warning-message-list">{items}</div>;
};
